/**
 * ページナビゲーションメニュー
 */
export const PageNavMenu = {
  selectors: {
    trigger: '.js-menu-toggle',
    children: '.c-menu__item-children',
  },

  classNames: {
    open: 'is-open',
    animating: 'is-animating',
  },

  init() {
    const triggers = document.querySelectorAll(this.selectors.trigger)

    if (!triggers.length) {
      return
    }

    triggers.forEach(trigger => {
      const target = trigger.nextElementSibling

      if (!target || !target.matches(this.selectors.children)) {
        return
      }

      trigger.setAttribute('aria-expanded', 'false')
      target.style.height = '0px'

      trigger.addEventListener('click', event => {
        event.preventDefault()

        this.toggle(event.currentTarget)
      })
    })
  },

  toggle(trigger) {
    const target = trigger.nextElementSibling

    if (!target || !target.matches(this.selectors.children)) {
      return
    }

    if (target.classList.contains(this.classNames.animating)) {
      return
    }

    const isExpanded = trigger.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      this.close(trigger, target)
      return
    }

    this.open(trigger, target)
  },

  open(trigger, target) {
    const parent = trigger.closest('.c-menu__item')

    target.classList.add(this.classNames.animating)
    target.style.height = `${target.scrollHeight}px`

    trigger.setAttribute('aria-expanded', 'true')
    parent?.classList.add(this.classNames.open)

    target.addEventListener(
      'transitionend',
      () => {
        target.style.height = 'auto'
        target.classList.remove(this.classNames.animating)
      },
      { once: true },
    )
  },

  close(trigger, target) {
    const parent = trigger.closest('.c-menu__item')

    target.classList.add(this.classNames.animating)
    target.style.height = `${target.scrollHeight}px`

    requestAnimationFrame(() => {
      target.style.height = '0px'
    })

    trigger.setAttribute('aria-expanded', 'false')
    parent?.classList.remove(this.classNames.open)

    target.addEventListener(
      'transitionend',
      () => {
        target.classList.remove(this.classNames.animating)
      },
      { once: true },
    )
  },
}
